<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiHomeOutline } from "@mdi/js"

export default {
  name: "HomeOutlineIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiHomeOutline,
    }
  }
}
</script>
